export const MIN_EXTRA_TIME_VALUE = 1;
export const MAX_EXTRA_TIME_VALUE = 28;
